<template>
  <div class="detail-view">
    <section class="site-hero detail-hero">
      <div class="site-hero__inner">
        <div class="crumb-row">
          <router-link class="crumb-link" to="/core-business">返回核心业务</router-link>
          <router-link class="crumb-link" :to="{ path: '/business-categories', query: { business: businessKey } }">返回分类列表</router-link>
        </div>
        <h1>{{ item ? item.title : "" }}</h1>
        <!-- <p>{{ item ? item.summary : "查看产品简介、适用企业和一般办理流程。" }}</p> -->
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-shell">
        <el-empty v-if="!item || !business" description="未找到对应产品详情，请返回分类列表重新选择。" />
        <div v-else class="detail-layout">
          <div class="panel-group">
            <article class="panel-card banner-card" :style="itemImageStyle">
              <ul class="bullet-list">
                <li v-for="entry in textLines(item.suitableFor)" :key="entry">{{ entry }}</li>
              </ul>
            </article>
            <article class="panel-card content-card">
              <h2>简介</h2>
              <p>{{ item.summary }}</p>
            </article>
            <article class="panel-card content-card">
              <h2>办理流程</h2>
              <ol class="step-list">
                <li v-for="entry in textLines(item.process)" :key="entry">{{ entry }}</li>
              </ol>
            </article>
            <article v-if="item.serviceCycle" class="panel-card content-card">
              <h2>服务周期</h2>
              <p>{{ item.serviceCycle }}</p>
            </article>
            <article v-if="textLines(item.materials).length" class="panel-card content-card">
              <h2>提供材料</h2>
              <ul class="bullet-list">
                <li v-for="entry in textLines(item.materials)" :key="entry">{{ entry }}</li>
              </ul>
            </article>
          </div>
          <aside class="sidebar">
            <article class="panel-card sidebar-card">
              <h3>业务归属</h3>
              <p>{{ business.title }}</p>
              <!-- <div class="tag-row">
                <el-tag v-for="tag in relatedTags" :key="tag" size="mini" effect="plain">{{ tag }}</el-tag>
              </div> -->
            </article>
            <article class="panel-card sidebar-card">
              <h3>同类产品</h3>
              <div class="related-list">
                <router-link
                  v-for="entry in relatedItems"
                  :key="entry.slug"
                  class="related-item"
                  :to="{ path: '/business-detail', query: { business: businessKey, item: entry.slug } }"
                >
                  {{ entry.title }}
                </router-link>
              </div>
            </article>
          </aside>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getBusinesses } from "@/api/website";

export default {
  name: "BusinessDetailView",
  data() {
    return {
      businesses: {}
    };
  },
  computed: {
    businessKey() {
      return this.$route.query.business;
    },
    itemKey() {
      return this.$route.query.item;
    },
    business() {
      return this.businesses[this.businessKey] || null;
    },
    item() {
      return this.business
        ? this.business.categories.find((entry) => entry.slug === this.itemKey) || null
        : null;
    },
    relatedItems() {
      return this.business
        ? this.business.categories.filter((entry) => entry.slug !== this.itemKey)
        : [];
    },
    relatedTags() {
      return [this.business && this.business.code, this.item && this.item.subtitle].filter(Boolean);
    },
    itemImageStyle() {
      const image = (this.item && this.item.image) || "/assets/eut.png";
      return {
        backgroundImage: `linear-gradient(90deg, rgba(3, 23, 50, 0.3), rgba(7, 55, 105, 0.2)), url("${image}")`
      };
    }
  },
  created() {
    getBusinesses().then((res) => {
      this.businesses = res.data || {};
    });
  },
  methods: {
    textLines(value) {
      if (Array.isArray(value)) {
        return value;
      }
      return String(value || "").split(/\n+/).map((entry) => entry.trim()).filter(Boolean);
    }
  }
};
</script>

<style lang="less" scoped>
.detail-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    url("/assets/banner.png") center / cover no-repeat;
}

.content-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.crumb-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
}

.crumb-link {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: var(--white);
}

.detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 0.72fr) minmax(280px, 0.28fr);
  gap: 22px;
}

.panel-group {
  display: grid;
  gap: 22px;
  .banner-card {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 260px;
    padding: 0;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    .bullet-list {
      margin: 0 0 0 20px;
      padding-left: 18px;
      color: var(--muted);
      li {
        color: #fff;
        margin-top: 10px;
      }
    }
  }
}

.content-card,
.sidebar-card {
  padding: 24px;
}
.content-card h2 {
  position: relative;
  padding-left: 20px;
    &::before{
    content: "";
    width: 8px;
    height: 22px;
    background: #d23131;
    display: block;
    position: absolute;
    left: 0;
    top: 10px;
    border-radius: 2px;
  }
}

.content-card h2,
.sidebar-card h3 {
  margin: 0 0 14px;
}

.content-card p {
  margin: 0;
  line-height: 1.8;
  color: var(--muted);
}

.bullet-list,
.step-list {
  margin: 0;
  padding-left: 18px;
  color: var(--muted);
}

.bullet-list li + li,
.step-list li + li {
  margin-top: 10px;
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.related-list {
  display: grid;
  gap: 10px;
}

.related-item {
  display: block;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f5f9ff;
  color: var(--navy);
  font-weight: 700;
}

@media (max-width: 1040px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .crumb-link {
    min-height: 34px;
    padding: 0 12px;
    font-size: 13px;
  }

  .content-card,
  .sidebar-card {
    padding: 20px;
  }

  .panel-group .banner-card {
    min-height: 180px;
  }

  .content-card h2,
  .sidebar-card h3 {
    font-size: 20px;
  }

  .content-card p,
  .bullet-list,
  .step-list,
  .related-item {
    font-size: 14px;
  }
}
</style>
